export function policyFor(configuration, category, field) {
  return configuration?.[category]?.[field] || 'optional'
}

export function stateFor(policy, acceptsAny = false) {
  return {
    hidden: policy === 'hidden',
    required: policy === 'required' || (policy === 'specific_or_any' && !acceptsAny),
    disabled: policy === 'hidden' || (policy === 'specific_or_any' && acceptsAny),
    preferenceVisible: policy === 'specific_or_any',
    optionalVisible: policy === 'optional'
  }
}
